"use client";

import { ActivityDisplayPreview } from "./previews";

type BoulderingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function BoulderingDisplay({
  data,
  participants,
}: BoulderingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="bouldering"
      data={data}
      participants={participants}
    />
  );
}
